import { useQueryClient, useMutation } from '@tanstack/react-query';
import { getTenantDetails } from "../orgPanelApiCalls";
import { key as editTenantKey } from "../queries/useGetTenantQuery";

const useGetTenantMutation = () => {
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: async (variables) => await getTenantDetails(variables.accountId),
        onSuccess: (data, variables) => {
            
            queryClient.setQueryData([editTenantKey], () => {
                return [
                    {
                        address1: data.address1,
                        address2: data.address2,
                        city: data.city,
                        companyName: data.companyName,
                        country: data.country,
                        dcgOrgId: data.dcgOrgId,
                        phone: data.phone,
                        portalAdminEmail: data.portalAdminEmail,
                        portalAdminName: data.portalAdminName,
                        state: data.state,
                        tenantAccountId: data.tenantAccountId,
                        zip:data.zip
                    }];
            });
        }
    })
}

export { useGetTenantMutation };